import React, { Component } from 'react';
import NavBar from 'components/Navbar';
import renderIf from 'render-if';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import { fromJS, Map } from 'immutable';
import styles from './CoachHeader.scss';// to import local scss fle
import CoachTabs from '../CoachTabs/CoachTabs';

class CoachHeader extends Component {
  static propTypes = {
    name: PropTypes.string,
    college: PropTypes.string,
    questionLink: PropTypes.string,
    city: PropTypes.string,
    sport: PropTypes.string,
    teamPageLink: PropTypes.string,
    tabListener: PropTypes.func,
    profile: PropTypes.shape(),
  };

  static defaultProps = {
    name: '',
    college: '',
    questionLink: '',
    city: '',
    sport: '',
    teamPageLink: '',
    profile: Map(),
    tabListener: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      removeDropdownLinks: true,
    };
  }

  render() {
    const { name, college, questionLink, city, sport, teamPageLink, profile } = this.props;
    const renderQuestionLink = renderIf(this.props.questionLink !== '');
    const immutableProfile = fromJS(profile);
    const renderTabs = renderIf(immutableProfile.size > 0);
    return (
      <div className={cn('row', styles.container)} >
        <div className={cn('col s12', styles.navContainer)}>
          <NavBar {...this.props} navBarUsedBy="coach" />
        </div>
        <div className={cn('col s12', styles.details)}>
          <div className={cn('col s12', styles.imageAndName)}>
            <div className={cn('col s4 m2 l1', styles.imageContainer)}>
              <div className={styles.userImage} />
            </div>
            <div className={cn('col s8 m10 l11', styles.basicInfo)}>
              <div className={cn('col s12', styles.infoText)}>
                <p className={styles.playerName}>{name}</p><br />
                <p className={styles.sports}>
                  <img src="https://media.dev.myrecruitboard.com/Images/Football-01.png" alt="football-icon" />
                  {sport} Coach
                </p><br />
                <p className={styles.location}>{college},{city}<br />
                </p>
                {/* eslint-disable */}
                <div className={cn('col s12 m10 l11', styles.basicInfoReplica)}>
                  <div className={cn('col s6 m4 l3', styles.removePadding)}>
                    <a href={teamPageLink} target="_blank">
                      <span className={styles.linkButton}> TEAM PAGE</span>
                    </a>
                  </div>
                    {renderQuestionLink(
                  <div className={cn('col s6 m4 l3', styles.removePadding)}>
                    <a href={questionLink} target="_blank">
                      <span className={styles.linkButton}> QUESTIONAIRE LINK</span>
                    </a>
                  </div>
                    )}
                </div>
                <Link to="/settings">
                  <button className={styles.coachEditButton}>EDIT PROFILE</button>
                </Link>
              </div>
              {/* <div className={cn('col s12 m2', styles.buttonInterested)}> */}
              {/* <span> */}
              {/* </span> */}
              {/* </div> */}

            </div>
          </div>
          <div className={cn('col s12', styles.otherDescription)}>
            <div className={cn('col s12', styles.basicInfoReplica)}>

              <div className={cn('col s6', styles.removePadding)}>
                <a href={teamPageLink} target="_blank">
                  <span className={styles.linkButton}> TEAM PAGE</span>
                </a>
              </div>
                {renderQuestionLink(
              <div className={cn('col s6', styles.removePadding)}>
                <a href={questionLink} target="_blank">
                  <span className={styles.linkButton}> QUESTIONAIRE LINK</span>
                </a>
              </div>
                )}
            </div>
              {/* eslint-enable */}
            {/* <div className={cn('col s12', styles.editInSmall)}> */}
            {/* <Link to="/settings"> */}
            {/* <button className={styles.editIcon} > */}
            {/* <img src="https://media.dev.myrecruitboard.com/Images/editIconProfile.png" alt="edit_icon" /> */}
            {/* </button> */}
            {/* </Link> */}
            {/* </div> */}
          </div>
        </div>
        {renderTabs(
          <div className={cn('col s12', styles.tabsContainer)}>
            <CoachTabs tabListener={this.props.tabListener} division={immutableProfile.get('division')} />
          </div>,
        )}
      </div>
    );
  }
}

export default CoachHeader;



// WEBPACK FOOTER //
// ./src/components/CoachHeader/CoachHeader.js